export default {
    GetCurrentUserInfo: 'GetCurrentUserInfo', //UserLogin
    GetUserLoginInfo: 'GetUserLoginInfo', //登入第一步
    UserLogin: 'UserLogin', //登入第二步
    LostLoginPassword: 'LostLoginPassword', //忘记密码
    CSGetBuildingUnitFloor: 'CSGetBuildingUnitFloor', //獲取座、樓層、單位
    CSBMGetFileDirs: 'CSBMGetFileDirs', //【文件】獲取單位文件夾列表
    CSBMGetFileList: 'CSBMGetFileList', //【文件】獲取指定文件列表
    CSBMGetFileUpdateRecord: 'CSBMGetFileUpdateRecord', //【文件】獲取文件更新記錄
    CSBMGetFileUpdateDetail: 'CSBMGetFileUpdateDetail', //【文件】根據記錄ID獲取詳情
    ReportRepairUserUploadFile: 'ReportRepairUserUploadFile', //【文件】上傳文件
    UserUploadFile: 'UserUploadFile', //【文件】上傳文件
    CSBMPostFileList: 'CSBMPostFileList', //【文件】提交添加文件列表

    CSBMGetManageInfo: 'CSBMGetManageInfo', //【联系人】獲取當前租戶信息
    CSBMGetManageUpdateRecord: 'CSBMGetManageUpdateRecord', //【联系人】獲取租戶信息修改記錄
    CSBMGetManageUpdateDetail: 'CSBMGetManageUpdateDetail', //【联系人】根據記錄ID獲取記錄詳情
    CSBMUpdateManageInfoCheck: 'CSBMUpdateManageInfoCheck', //【联系人】A修改租房信息檢測
    CSBMUpdateManageInfo: 'CSBMUpdateManageInfo', //【联系人】修改租戶信息

    foGetCaseRecord: 'foGetCaseRecord', //【裝修管理相關】獲取裝修申請記錄列表
    foGetCaseDetails: 'foGetCaseDetails', //【裝修管理相關】獲取裝修申請記錄詳情
    foUpdateCaseToSR: 'foUpdateCaseToSR', //【裝修管理相關】租戶提交到SR審批
    foGetCaseFileList: 'foGetCaseFileList', //【裝修管理相關】獲取租戶已上傳文件列表
    foUploadCaseFile: 'foUploadCaseFile', //【裝修管理相關】保存租戶上傳文件列表
    foDeleteCaseFile: 'foDeleteCaseFile', //【裝修管理相關】刪除租戶已上傳文件列表
    foGetCaseLayerComment: 'foGetCaseLayerComment', //【裝修管理相關】獲取類型批閱詳情
    foUpdateCaseResubmit: 'foUpdateCaseResubmit', //【裝修管理相關】重新提交審批
    foSendToPurveyor: 'foSendToPurveyor', //【裝修管理相關】提交第三方服務商郵件信息
    foGetPurveyorList: 'foGetPurveyorList', //【裝修管理相關】獲取第三方服務商提交列表

    foLogin_3rd: 'foLogin_3rd', //【裝修管理相關】第三方服務商登錄接口
    foGetDetails_3rd: 'foGetDetails_3rd', //【裝修管理相關】第三方服務商獲取Case詳情
    foGetLayerComment_3rd: 'foGetLayerComment_3rd', //【裝修管理相關】第三方服務商獲取類型批閱詳情
    foUpdateResubmit_3rd: 'foUpdateResubmit_3rd', //【裝修管理相關】第三方服務商重新提交審批
    foGetFileList_3rd: 'foGetFileList_3rd', //【裝修管理相關】第三方服務商，獲取已上傳文件列表
    foDeleteFile_3rd: 'foDeleteFile_3rd', //【裝修管理相關】第三方服務商，刪除已上傳文件
    foUploadFile_3rd: 'foUploadFile_3rd', //【裝修管理相關】第三方服務商，保存上傳文件

    GetInboxMsgList: 'GetInboxMsgList', //【消息】消息列表
    OperateInboxMsg: 'OperateInboxMsg', //【消息】消息操作

    EditPassword: 'EditPassword', //修改密码

    GetBannerList: 'GetBannerList', //獲取Banner列表
    GetRuleInfoVJ: 'GetRuleInfoVJ', //獲取GetRuleInfoVJ

    GetNoticeClassList: 'GetNoticeClassList', //【安全資訊】獲取通告分類
    GetNoticeListByClassId: 'GetNoticeListByClassId', //【安全資訊】獲取通告列表
    GetNoticeContent: 'GetNoticeContent', //【安全資訊】獲取通告內容

    foGetCaseRecordByBFU: 'foGetCaseRecordByBFU', //【裝修管理相關】獲取裝修申請記錄詳情
    foGetLayerFileForLastSubmit: 'foGetLayerFileForLastSubmit', //【裝修管理相關】獲取租戶最後一次提交的文件列表

    GetNoticeContentByGuid: 'GetNoticeContentByGuid', //根據Guid獲取通告內容（外部使用，用戶未登錄狀態）
    GetNoticeClassDetailsByClassId: 'GetNoticeClassDetailsByClassId', //獲取通告分類詳情
    GetContactInfoList: 'GetContactInfoList',  //獲取聯絡我們信息

    GetReportRepairClass: 'GetReportRepairClass', //【報告維修】獲取事項分類與位置
    GetReportRepairList: 'GetReportRepairList', //【報告維修】報事單列表
    SubmitReportRepair: 'SubmitReportRepair', //【報告維修】用戶提交報事
    GetReportRepairDetails:'GetReportRepairDetails', //【報告維修】報事單詳細

    DRManageApplicationList:'DRManageApplicationList', //【施工申请服务】獲取用戶已填寫申請表列表
    DRManageUpdateOpenDate:'DRManageUpdateOpenDate', //【施工申请服务】提交預計開業日期
    DRManageGetBuildingInfo:'DRManageGetBuildingInfo', //【施工申请服务】獲取樓座室預計開工日期
    GetOtherInfo:'GetOtherInfo', //【施工申请服务】獲取相關信息
    DRManageGetDocumentsAdd:"DRManageGetDocumentsAdd",  //【施工申请服务】保存裝修资料/多個信息提交
    DRManageGetDocumentsList:"DRManageGetDocumentsList",  //【施工申请服务】獲取文檔列表
    SubmitDRManageApplication:"SubmitDRManageApplication",  //【施工申请服务】提交裝修申請表
    GetBasicData:"GetBasicData",  //【施工申请服务】獲取基礎數據
    DRManageApplicationDetail:"DRManageApplicationDetail",  //【施工申请服务】獲取申請表詳細信息功能
    SubmitDRDisclaimer:"SubmitDRDisclaimer",   //【施工申请服务】提交免責聲明
    GetElectronicQuestionList:"GetElectronicQuestionList",  //【施工申请服务】獲取申請表（空白）列表頁
    DRManageTemplateSend:"DRManageTemplateSend",  //【施工申请服务】提交三方填表信息並發郵件
    DeleteDRManageApplication:"DeleteDRManageApplication",  //【施工申请服务】删除申请表
    DRManageGetDocumentsDel:"DRManageGetDocumentsDel",  //【施工申请服务】刪除裝修资料
    DRManageGetDocumentsEdit:"DRManageGetDocumentsEdit",  //【施工申请服务】修改裝修资料

    getFormList: 'GetDownloadFormList',
    GetWebUrl:'GetWebUrl' //獲取問答iframe 訪問地址
}



// WEBPACK FOOTER //
// ./src/api/url.js